import * as React from "react";
const SvgMenu = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", fill: "none", stroke: "currentColor", strokeWidth: 6, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12,15h40 M12,32h40 M12,49h40" }));
export default SvgMenu;
